"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnVideo = void 0;
const react_1 = __importDefault(require("react"));
const useScript_1 = __importDefault(require("../../hooks/useScript"));
function ColumnVideo(_a) {
    var { className, videoId, ratio = '16:9' } = _a, props = __rest(_a, ["className", "videoId", "ratio"]);
    const generateRatioPadding = (ratioString) => {
        const [ratioWidth, ratioHeight] = ratioString.split(':');
        return `${(parseInt(ratioHeight) / parseInt(ratioWidth)) * 100}%`;
    };
    (0, useScript_1.default)('https://players.brightcove.net/1143621176001/YJXhO2osU_default/index.min.js');
    return (react_1.default.createElement("div", { className: "w-full h-0 relative", style: { paddingBottom: generateRatioPadding(ratio) } },
        react_1.default.createElement("video-js", Object.assign({ style: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
            }, id: "myembedvjs", "data-account": "1143621176001", "data-player": "YJXhO2osU", "data-embed": "default", controls: "", "data-video-id": videoId, "data-playlist-id": "", "data-application-id": "" }, props))));
}
exports.ColumnVideo = ColumnVideo;
